module.exports = __webpack_public_path__ + "img/Repubblica-Italiana.a68c8aac.svg";